import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import MemberInfo from './memberInfo.vue';
import MemberControl from './memberControl.vue';
import { UserInfo } from '../../../../stores/room';
import { useBasicStore } from '@/stores/basic';
import { storeToRefs } from 'pinia';
import { UserRoles } from '@/constants/render';

interface Props {
  userInfo: UserInfo,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    userInfo: null
  },
  setup(__props: any) {

const props = __props as {
  userInfo: UserInfo,
}


const basicStore = useBasicStore();
const { userRole } = storeToRefs(basicStore);

const showMemberControl = ref(false);

function handleMouseEnter() {
  if (userRole.value === UserRoles.USER_ROLE_MAJOR){
    showMemberControl.value = true;
  }
}

function handleMouseLeave() {
  showMemberControl.value = false;
}


return { __sfc: true,props, basicStore, userRole, showMemberControl, handleMouseEnter, handleMouseLeave, MemberInfo, MemberControl }
}

})